import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Layout } from "../components/Navbar";
import { LOGO_URL } from "../api";
import { Stethoscope, Video, CalendarHeart, ShoppingBag, ShieldCheck, HardDrive, FileText, Activity } from "lucide-react";

export default function Home() {
  const { t } = useTranslation();
  const features = [
    { icon: <Stethoscope size={22}/>, k:"1" }, { icon:<Video size={22}/>, k:"2" },
    { icon:<CalendarHeart size={22}/>, k:"3" }, { icon:<ShoppingBag size={22}/>, k:"4" },
    { icon:<ShieldCheck size={22}/>, k:"5" }, { icon:<HardDrive size={22}/>, k:"6" },
    { icon:<FileText size={22}/>, k:"7" }, { icon:<Activity size={22}/>, k:"8" }];
  return (
    <Layout>
      <section className="yp-hero-bg py-16 md:py-24">
        <div className="yp-container grid md:grid-cols-2 gap-10 items-center">
          <div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-tight">
              HEALTHCARE NETWORK
            </h1>
            <p className="mt-5 text-lg text-slate-600 leading-relaxed">{t("home.hero_sub")}</p>
          </div>
          <div className="flex justify-center">
            <img src={LOGO_URL} alt="YouPAM" className="max-w-[380px] w-full h-auto drop-shadow-xl" />
          </div>
        </div>
      </section>
      <div className="yp-container flex flex-wrap items-center gap-3 md:justify-center pt-4 md:pt-6 pb-14 md:pb-20">
        <Link to="/register/user" className="yp-btn yp-btn-primary" data-testid="cta-register-user">{t("home.cta_user")}</Link>
        <Link to="/register/pro" className="yp-btn yp-btn-outline" data-testid="cta-register-pro">{t("home.cta_pro")}</Link>
        <Link to="/register/org" className="yp-btn yp-btn-outline" data-testid="cta-register-org">{t("home.cta_org")}</Link>
      </div>
      <section className="py-16"><div className="yp-container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {features.map(f => (
          <div key={f.k} className="yp-card p-6 yp-gradient-border" data-testid={`home-feature-${f.k}`}>
            <div className="mb-3 text-slate-700">{f.icon}</div>
            <h3 className="text-lg font-semibold mb-2">{t(`home.feature_${f.k}_title`)}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{t(`home.feature_${f.k}_desc`)}</p>
          </div>))}
      </div></section>
    </Layout>
  );
}
